export enum ManagerQueueDataColumns {
  patient,
  documentType,
  receivedDate,
  age,
}
